function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import partial from 'ramda/src/partial';
import pathOr from 'ramda/src/pathOr';
import { clearQuote, retrieveAttributesPromise, retrieveOfferingContextPromise, searchInventoryPromise, updateCartSummaryPromise } from '../actions/offering.order.actions';
import { retrieveWalletPromise } from '../actions/customer.ewallet.actions';
import { FINANCE_SERVICE_FEATURES_IDENTIFIER_VALUE, NOTIFICATION_TIME_LENGTH } from '../../customercare.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import ApiConstants from 'invision-core/src/api/constants';
import { getUiNotificationService } from 'invision-core/src/components/injectables/injector.helper';
import { RouteParams } from 'invision-core/src/components/router/router.selectors';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import CustomerCareKeys from '../../locales/keys';
import createWizardActions from './wizard.action.helper';
import { EditCustomerInfoSelector } from '../selectors/new.connect.wizard.selectors';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
var actionWithPayload = partial(function (type, payload) {
  return {
    type: type,
    payload: payload
  };
});
export default (function (prefix) {
  var basicWizardActions = createWizardActions(prefix);
  var CANCEL_WIZARD = basicWizardActions.CANCEL_WIZARD;
  var cancelWizard = basicWizardActions.cancelWizard;
  var GO_TO_NEXT_STEP = basicWizardActions.GO_TO_NEXT_STEP;
  var GO_TO_PREVIOUS_STEP = basicWizardActions.GO_TO_PREVIOUS_STEP;
  var GO_TO_STEP = basicWizardActions.GO_TO_STEP;
  var goToNextStep = basicWizardActions.goToNextStep;
  var goToPreviousStep = basicWizardActions.goToPreviousStep;
  var goToStep = basicWizardActions.goToStep;
  var RESET_OFFER_ADDITIONAL_PROPERTIES = "".concat(prefix, "_RESET_OFFER_ADDITIONAL_PROPERTIES");
  var RESTORE_OPTION_DEFAULT_PRICING = "".concat(prefix, "_RESTORE_BULK_OPTION_DEFAULT_PRICING");
  var SAVE_BWS_OPTION_EDIT = 'SAVE_BWS_OPTION_EDIT';
  var SAVE_OPTION_PRICING = "".concat(prefix, "_SAVE_OPTION_PRICING");
  var SET_ATTRIBUTE_SEARCHING_INVENTORY = "".concat(prefix, "_SET_ATTRIBUTE_SEARCHING_INVENTORY");
  var SET_CURRENT_STEP_IS_INVALID = basicWizardActions.SET_CURRENT_STEP_IS_INVALID;
  var SET_EDIT_ATTRIBUTE_GROUPS = "".concat(prefix, "_SET_EDIT_ATTRIBUTE_GROUPS");
  var SET_EDIT_CART_ADDITIONAL_PROPERTY = "".concat(prefix, "_SET_EDIT_CART_ADDITIONAL_PROPERTY");
  var SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE = "".concat(prefix, "_SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE");
  var SET_EDIT_OFFER_ADDITIONAL_PROPERTY = "".concat(prefix, "_SET_EDIT_OFFER_ADDITIONAL_PROPERTY");
  var SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE = "".concat(prefix, "_SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE");
  var SET_EDIT_OPTION = "".concat(prefix, "_SET_EDIT_OPTION");
  var SET_EDIT_ORDER_ADDITIONAL_PROPERTY = "".concat(prefix, "_SET_EDIT_ORDER_ADDITIONAL_PROPERTY");
  var SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE = "".concat(prefix, "_SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE");
  var SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS = "".concat(prefix, "_SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS");
  var SET_PAYMENT_INFO = "".concat(prefix, "_SET_PAYMENT_INFO");
  var SET_SELECTED_WIZARD_TAB = basicWizardActions.SET_SELECTED_WIZARD_TAB;
  var setCurrentStepIsInvalid = basicWizardActions.setCurrentStepIsInvalid;
  var setSelectedTab = basicWizardActions.setSelectedTab;
  var SET_SELECTED_OFFER = "".concat(prefix, "_SET_SELECTED_OFFER");
  var SET_SELECTED_FACETS_EDIT_COPY = "".concat(prefix, "_SET_SELECTED_FACETS_EDIT_COPY");
  var SET_SELECTED_OFFER_EDIT_COPY = "".concat(prefix, "_SET_SELECTED_OFFER_EDIT_COPY");
  var SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY = "".concat(prefix, "_SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY");
  var UPDATE_PAYMENT_INFO = "".concat(prefix, "_UPDATE_PAYMENT_INFO");
  var UPDATE_BILL_CYCLE = "".concat(prefix, "_UPDATE_BILL_CYCLE");
  var UPDATE_INVENTORY_SELECTION = "".concat(prefix, "_UPDATE_INVENTORY_SELECTION");
  var UPDATE_OFFER_ATTRIBUTE = "".concat(prefix, "_UPDATE_OFFER_ATTRIBUTE");
  var UPDATE_PORT_IN_REQUEST = "".concat(prefix, "_UPDATE_PORT_IN_REQUEST");
  var SEND_PORT_IN_OR_ITEM_RESERVATION = "".concat(prefix, "_SEND_PORT_IN_OR_ITEM_RESERVATION");
  var UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE = "".concat(prefix, "_UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE");
  var UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL = "".concat(prefix, "_UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL");
  var UPDATE_EDIT_BRI_PRICE = "".concat(prefix, "_UPDATE_EDIT_BRI_PRICE");
  var UPDATE_SELECTED_SERVICE_FEATURES = "".concat(prefix, "_UPDATE_SELECTED_SERVICE_FEATURES");
  var UPDATE_SHOPPING_CART = {
    BEGIN: "".concat(prefix, "_UPDATE_SHOPPING_CART_BEGIN"),
    SUCCESS: "".concat(prefix, "_UPDATE_SHOPPING_CART_SUCCESS"),
    FAILURE: "".concat(prefix, "_UPDATE_SHOPPING_CART_FAILURE")
  };
  var UPDATE_SHOPPING_CART_EVENTS = [UPDATE_SHOPPING_CART.BEGIN, UPDATE_SHOPPING_CART.SUCCESS, UPDATE_SHOPPING_CART.FAILURE];
  var RETRIEVE_ADDRESSES = {
    BEGIN: "".concat(prefix, "_RETRIEVE_ADDRESSES_BEGIN"),
    SUCCESS: "".concat(prefix, "_RETRIEVE_ADDRESSES_SUCCESS"),
    FAILURE: "".concat(prefix, "_RETRIEVE_ADDRESSES_FAILURE")
  };
  var RETRIEVE_ADDRESSES_TYPES = [RETRIEVE_ADDRESSES.BEGIN, RETRIEVE_ADDRESSES.SUCCESS, RETRIEVE_ADDRESSES.FAILURE];
  var setAttributeSearchingInventory = actionWithPayload([SET_ATTRIBUTE_SEARCHING_INVENTORY]);
  var setEditAttributeGroups = actionWithPayload([SET_EDIT_ATTRIBUTE_GROUPS]);
  var setEditPhysicalAttributeGroups = actionWithPayload([SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS]);
  var setSelectedOfferEditCopy = actionWithPayload([SET_SELECTED_OFFER_EDIT_COPY]);
  var updatePaymentInfo = actionWithPayload([UPDATE_PAYMENT_INFO]);
  var updateBillCycle = actionWithPayload([UPDATE_BILL_CYCLE]);
  var setPaymentInfo = function setPaymentInfo(paymentInfo) {
    return {
      type: SET_PAYMENT_INFO,
      payload: paymentInfo
    };
  };
  var setSelectedOffer = function setSelectedOffer(selectedOfferId) {
    return {
      type: SET_SELECTED_OFFER,
      payload: selectedOfferId
    };
  };
  var clearQuoteAndSetSelectedOffer = function clearQuoteAndSetSelectedOffer(selectedOfferId) {
    return function (dispatch) {
      dispatch(clearQuote());
      dispatch(setSelectedOffer(selectedOfferId));
    };
  };
  var fetchAttributes = function fetchAttributes(_ref) {
    var changeOfferingInstanceId = _ref.changeOfferingInstanceId,
      _ref$completedAttribu = _ref.completedAttributes,
      completedAttributes = _ref$completedAttribu === void 0 ? [] : _ref$completedAttribu,
      _ref$completedDecisio = _ref.completedDecisions,
      completedDecisions = _ref$completedDecisio === void 0 ? [] : _ref$completedDecisio,
      _ref$completedPhysica = _ref.completedPhysicalAttributes,
      completedPhysicalAttributes = _ref$completedPhysica === void 0 ? [] : _ref$completedPhysica,
      _ref$isConvergentBill = _ref.isConvergentBiller,
      isConvergentBiller = _ref$isConvergentBill === void 0 ? true : _ref$isConvergentBill,
      isEditOffer = _ref.isEditOffer,
      _ref$isReconnectActio = _ref.isReconnectAction,
      isReconnectAction = _ref$isReconnectActio === void 0 ? false : _ref$isReconnectActio,
      offeringId = _ref.offeringId,
      offeringInstanceId = _ref.offeringInstanceId,
      pickupId = _ref.pickupId,
      transitionOutcomes = _ref.transitionOutcomes,
      useSavedShoppingCart = _ref.useSavedShoppingCart;
    return function (dispatch, getState) {
      var state = getState(),
        routeParams = RouteParams(state),
        customerId = routeParams.customerId,
        newConnect = customerId ? {} : EditCustomerInfoSelector(state);
      return retrieveAttributesPromise({
        changeOfferingInstanceId: changeOfferingInstanceId,
        completedDecisions: completedDecisions.concat(completedAttributes).concat(completedPhysicalAttributes),
        customerId: customerId,
        customerLanguage: newConnect.Language,
        dispatch: dispatch,
        isConvergentBiller: isConvergentBiller,
        isEditOffer: isEditOffer,
        isReconnectAction: isReconnectAction,
        offeringId: offeringId,
        offeringInstanceId: offeringInstanceId,
        pickupId: pickupId,
        subscriberSubtenantId: newConnect.SubtenantId,
        transitionOutcomes: transitionOutcomes,
        useSavedShoppingCart: useSavedShoppingCart
      });
    };
  };
  var fetchAttributesAndNavigate = function fetchAttributesAndNavigate(_ref2) {
    var offerId = _ref2.offerId,
      offeringInstanceId = _ref2.offeringInstanceId,
      _ref2$completedDecisi = _ref2.completedDecisions,
      completedDecisions = _ref2$completedDecisi === void 0 ? [] : _ref2$completedDecisi,
      _ref2$completedAttrib = _ref2.completedAttributes,
      completedAttributes = _ref2$completedAttrib === void 0 ? [] : _ref2$completedAttrib,
      _ref2$completedPhysic = _ref2.completedPhysicalAttributes,
      completedPhysicalAttributes = _ref2$completedPhysic === void 0 ? [] : _ref2$completedPhysic,
      _ref2$skipAttributesT = _ref2.skipAttributesTargetStep,
      skipAttributesTargetStep = _ref2$skipAttributesT === void 0 ? CustomerCareKeys.WIZARD.STEPS.CUSTOMER : _ref2$skipAttributesT;
    return function (dispatch, getState) {
      var newConnect = EditCustomerInfoSelector(getState());
      return retrieveAttributesPromise({
        dispatch: dispatch,
        offeringId: offerId,
        offeringInstanceId: offeringInstanceId,
        completedDecisions: completedDecisions.concat(completedAttributes).concat(completedPhysicalAttributes),
        customerLanguage: newConnect.Language,
        subscriberSubtenantId: newConnect.SubtenantId
      }).then(function (response) {
        var visibleValueDecisions = response.Context.ValueDecisions.filter(function (decision) {
          // if there is a DependentServiceAttributeId then the attribute is hidden
          // if they are all hidden, then we don't need to show attributes page
          // if IsServiceFeatureAvailable is false and ServiceAttributeId is Finance service feature then we don't need to show attributes page
          return !decision.DependentServiceAttributeId && !(!decision.IsServiceFeatureAvailable && decision.ServiceAttributeId === FINANCE_SERVICE_FEATURES_IDENTIFIER_VALUE);
        });
        if (visibleValueDecisions.length > 0 || response.Context.PhysicalInventoryDecisions && response.Context.PhysicalInventoryDecisions.length > 0) {
          dispatch(goToNextStep());
        } else {
          dispatch(goToStep(skipAttributesTargetStep));
        }
      }).catch(function (error) {
        if (!pathOr([], ['FaultData'], error).length) {
          getUiNotificationService().error(error.translatedMessage ? error.translatedMessage : i18n.translate(CustomerCareKeys.DECISIONS_ERROR), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
      });
    };
  };
  var fetchDecisionsAndNavigate = function fetchDecisionsAndNavigate(_ref3) {
    var offerId = _ref3.offerId,
      customerId = _ref3.customerId,
      _ref3$skipAttributesT = _ref3.skipAttributesTargetStep,
      skipAttributesTargetStep = _ref3$skipAttributesT === void 0 ? CustomerCareKeys.WIZARD.STEPS.CUSTOMER : _ref3$skipAttributesT,
      _ref3$isConvergentBil = _ref3.isConvergentBiller,
      isConvergentBiller = _ref3$isConvergentBil === void 0 ? true : _ref3$isConvergentBil,
      _ref3$segmentationCon = _ref3.segmentationContext,
      segmentationContext = _ref3$segmentationCon === void 0 ? [] : _ref3$segmentationCon;
    return function (dispatch, getState) {
      dispatch(clearQuoteAndSetSelectedOffer(offerId));

      // Set Offers step to invalid until the api call is successful
      dispatch(setCurrentStepIsInvalid(true));
      var state = getState();
      var newConnect = EditCustomerInfoSelector(state);
      var subtenantId = !customerId ? newConnect.SubtenantId : null;
      return dispatch(retrieveOfferingsMetadata([offerId])).then(function () {
        return retrieveOfferingContextPromise(dispatch, offerId, customerId, false, undefined, isConvergentBiller, segmentationContext, newConnect.Language, subtenantId).then(function (response) {
          dispatch(setCurrentStepIsInvalid(false));
          if (response.Context.Decisions.length > 0) {
            dispatch(goToNextStep());
          } else {
            retrieveAttributesPromise({
              dispatch: dispatch,
              offeringId: offerId,
              customerId: customerId,
              isConvergentBiller: isConvergentBiller,
              customerLanguage: newConnect.Language,
              subscriberSubtenantId: subtenantId
            }).then(function (response) {
              if (response.Context.ValueDecisions.length > 0 || response.Context.PhysicalInventoryDecisions && response.Context.PhysicalInventoryDecisions.length > 0) {
                dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES));
              } else if (customerId && skipAttributesTargetStep === CustomerCareKeys.WIZARD.STEPS.CHECKOUT) {
                dispatch(goToStep(skipAttributesTargetStep));
              } else {
                dispatch(goToStep(skipAttributesTargetStep));
              }
            });
          }
        });
      }).catch(function (error) {
        getUiNotificationService().error(error.translatedMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        dispatch(setSelectedOffer(null));
      });
    };
  };
  var fetchWallet = function fetchWallet(customerId) {
    return function (dispatch) {
      var data = {
        customerId: customerId
      };
      return retrieveWalletPromise(dispatch, data);
    };
  };
  var searchAttributeInventory = function searchAttributeInventory(attribute) {
    return function (dispatch, getState) {
      var routeParams = RouteParams(getState());
      dispatch(setAttributeSearchingInventory(attribute.id));
      var inventoryTypeId = attribute.inventoryItemReservation ? attribute.inventoryItemReservation.inventoryTypeId : attribute.inventoryTypeId;
      searchInventoryPromise(dispatch, inventoryTypeId, [], routeParams.customerId);
    };
  };
  var setSelectedFacetsEditCopy = function setSelectedFacetsEditCopy(facetId, isSelected) {
    return {
      type: SET_SELECTED_FACETS_EDIT_COPY,
      payload: {
        facetId: facetId,
        isSelected: isSelected
      }
    };
  };
  var setSelectedOfferingChargeTypesEditCopy = function setSelectedOfferingChargeTypesEditCopy(offeringChargeTypeId, isSelected) {
    return {
      type: SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY,
      payload: {
        offeringChargeTypeId: offeringChargeTypeId,
        isSelected: isSelected
      }
    };
  };
  var updateAttribute = function updateAttribute(attributeId, formValue) {
    return {
      type: UPDATE_OFFER_ATTRIBUTE,
      payload: {
        attributeId: attributeId,
        formValue: formValue
      }
    };
  };
  var updateSelectedServiceFeatures = function updateSelectedServiceFeatures(attributeId, selectedServiceFeatures, billerRuleInstanceDetails) {
    return {
      type: UPDATE_SELECTED_SERVICE_FEATURES,
      payload: {
        attributeId: attributeId,
        billerRuleInstanceDetails: billerRuleInstanceDetails,
        selectedServiceFeatures: selectedServiceFeatures
      }
    };
  };
  var updatePortInRequest = function updatePortInRequest(attributeId, portInData, token, address) {
    return {
      type: UPDATE_PORT_IN_REQUEST,
      payload: {
        attributeId: attributeId,
        portInData: portInData,
        token: token,
        address: address
      }
    };
  };
  var sendPortInOrItemReservation = function sendPortInOrItemReservation(attributeId, sendPortInReservation) {
    return {
      type: SEND_PORT_IN_OR_ITEM_RESERVATION,
      payload: {
        attributeId: attributeId,
        sendPortInReservation: sendPortInReservation
      }
    };
  };
  var updateOfferPhysicalInventoryTypeAttribute = function updateOfferPhysicalInventoryTypeAttribute(pricingPlanId, inventoryId, typeAttributeId, value) {
    return {
      type: UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE,
      payload: {
        pricingPlanId: pricingPlanId,
        inventoryId: inventoryId,
        typeAttributeId: typeAttributeId,
        value: value
      }
    };
  };
  var updateOfferPhysicalInventoryMakeAndModel = function updateOfferPhysicalInventoryMakeAndModel(pricingPlanId, inventoryId, makeId, modelId) {
    return {
      type: UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL,
      payload: {
        pricingPlanId: pricingPlanId,
        inventoryId: inventoryId,
        makeId: makeId,
        modelId: modelId
      }
    };
  };
  var updateInventorySelection = function updateInventorySelection(attributeId, InventoryItem, formValue) {
    return {
      type: UPDATE_INVENTORY_SELECTION,
      payload: {
        attributeId: attributeId,
        InventoryItem: InventoryItem,
        formValue: formValue
      }
    };
  };
  var updateCart = function updateCart(offeringId, offeringInstanceId, completedDecisions, isModify, customerId, callback, contextOfferingAction, transitionContext) {
    var isConvergentBiller = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
    var customerLanguage = arguments.length > 9 ? arguments[9] : undefined;
    var pickupId = arguments.length > 10 ? arguments[10] : undefined;
    var changeOfferingInstanceId = arguments.length > 11 ? arguments[11] : undefined;
    var useSavedShoppingCart = arguments.length > 12 ? arguments[12] : undefined;
    return function (dispatch, getState) {
      // TODO: Customer Order - we should not be grabbing state in actions
      var state = getState();
      var newConnect = EditCustomerInfoSelector(state);
      var subtenantId = !customerId ? newConnect.SubtenantId : null;
      var postalCode = customerId ? null : newConnect.postalCode;
      // Disallow the user from submitting again until the request is done
      dispatch(setCurrentStepIsInvalid(true));
      updateCartSummaryPromise(dispatch, offeringId, offeringInstanceId, completedDecisions, isModify, customerId, contextOfferingAction, transitionContext, isConvergentBiller, customerLanguage, subtenantId, postalCode, pickupId, changeOfferingInstanceId, useSavedShoppingCart).then(callback).catch(function (err) {
        getUiNotificationService().error(err.translatedMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }).finally(function () {
        // Make it ok for the user to submit again
        dispatch(setCurrentStepIsInvalid(false));
      });
    };
  };
  var setEditOption = function setEditOption(option) {
    return {
      type: SET_EDIT_OPTION,
      payload: option
    };
  };
  var restoreOptionDefaultPricing = function restoreOptionDefaultPricing(optionId) {
    return {
      type: RESTORE_OPTION_DEFAULT_PRICING,
      payload: optionId
    };
  };
  var updateEditOptionPrice = function updateEditOptionPrice(params) {
    return {
      type: UPDATE_EDIT_BRI_PRICE,
      payload: params
    };
  };
  var saveOptionEdit = function saveOptionEdit(option) {
    return {
      type: SAVE_BWS_OPTION_EDIT,
      payload: option
    };
  };
  var saveBulkPricing = function saveBulkPricing(option) {
    return {
      type: SAVE_OPTION_PRICING,
      payload: option
    };
  };
  var retrieveAddressesPromise = function retrieveAddressesPromise(dispatch, customerId) {
    return ThunkHelper(dispatch, RETRIEVE_ADDRESSES_TYPES, {
      method: 'post',
      url: 'SubscriberManagement/RetrieveAddresses',
      data: {
        IncludeRemoved: false
      },
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
    });
  };
  var fetchAddresses = function fetchAddresses(customerId) {
    return function (dispatch) {
      return retrieveAddressesPromise(dispatch, customerId).catch(function (errorPayload) {
        getUiNotificationService().error(errorPayload.translatedMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    };
  };
  var updateShoppingCartPromise = function updateShoppingCartPromise(dispatch, customerId, shoppingCart) {
    var redemptionCodes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var additionalOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    return ThunkHelper(dispatch, UPDATE_SHOPPING_CART_EVENTS, {
      method: 'post',
      url: 'SubscriberManagement/UpdateShoppingCart',
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
      data: Object.assign({
        PersistCart: true,
        RedemptionCodes: redemptionCodes,
        ShoppingCart: shoppingCart,
        CombineProducts: false
      }, additionalOptions)
    });
  };
  var updateShoppingCart = function updateShoppingCart(customerId, shoppingCart, redemptionCodes) {
    var additionalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return function (dispatch) {
      return updateShoppingCartPromise(dispatch, customerId, shoppingCart, redemptionCodes, additionalOptions);
    };
  };
  var setEditCartAdditionalProperty = function setEditCartAdditionalProperty(additionalProperties) {
    return {
      type: SET_EDIT_CART_ADDITIONAL_PROPERTY,
      payload: additionalProperties
    };
  };
  var setEditCartAdditionalPropertyOnChange = function setEditCartAdditionalPropertyOnChange(id, newValue) {
    return {
      type: SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE,
      payload: {
        id: id,
        newValue: newValue
      }
    };
  };
  var setEditOrderAdditionalProperty = function setEditOrderAdditionalProperty(additionalProperties) {
    return {
      type: SET_EDIT_ORDER_ADDITIONAL_PROPERTY,
      payload: additionalProperties
    };
  };
  var setEditOrderAdditionalPropertyOnChange = function setEditOrderAdditionalPropertyOnChange(id, newValue) {
    return {
      type: SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE,
      payload: {
        id: id,
        newValue: newValue
      }
    };
  };
  var resetOfferAdditionalProperties = function resetOfferAdditionalProperties() {
    return {
      type: RESET_OFFER_ADDITIONAL_PROPERTIES
    };
  };
  var setEditOfferAdditionalProperty = function setEditOfferAdditionalProperty(additionalProperties) {
    return {
      type: SET_EDIT_OFFER_ADDITIONAL_PROPERTY,
      payload: additionalProperties
    };
  };
  var setEditOfferAdditionalPropertyOnChange = function setEditOfferAdditionalPropertyOnChange(id, newValue) {
    return {
      type: SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE,
      payload: {
        id: id,
        newValue: newValue
      }
    };
  };
  return {
    CANCEL_WIZARD: CANCEL_WIZARD,
    GO_TO_NEXT_STEP: GO_TO_NEXT_STEP,
    GO_TO_PREVIOUS_STEP: GO_TO_PREVIOUS_STEP,
    GO_TO_STEP: GO_TO_STEP,
    RESET_OFFER_ADDITIONAL_PROPERTIES: RESET_OFFER_ADDITIONAL_PROPERTIES,
    RESTORE_OPTION_DEFAULT_PRICING: RESTORE_OPTION_DEFAULT_PRICING,
    RETRIEVE_ADDRESSES: RETRIEVE_ADDRESSES,
    SAVE_OPTION_PRICING: SAVE_OPTION_PRICING,
    SAVE_BWS_OPTION_EDIT: SAVE_BWS_OPTION_EDIT,
    SEND_PORT_IN_OR_ITEM_RESERVATION: SEND_PORT_IN_OR_ITEM_RESERVATION,
    SET_ATTRIBUTE_SEARCHING_INVENTORY: SET_ATTRIBUTE_SEARCHING_INVENTORY,
    SET_CURRENT_STEP_IS_INVALID: SET_CURRENT_STEP_IS_INVALID,
    SET_EDIT_ATTRIBUTE_GROUPS: SET_EDIT_ATTRIBUTE_GROUPS,
    SET_EDIT_OPTION: SET_EDIT_OPTION,
    SET_EDIT_CART_ADDITIONAL_PROPERTY: SET_EDIT_CART_ADDITIONAL_PROPERTY,
    SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE: SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE,
    SET_EDIT_ORDER_ADDITIONAL_PROPERTY: SET_EDIT_ORDER_ADDITIONAL_PROPERTY,
    SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE: SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE,
    SET_EDIT_OFFER_ADDITIONAL_PROPERTY: SET_EDIT_OFFER_ADDITIONAL_PROPERTY,
    SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE: SET_EDIT_OFFER_ADDITIONAL_PROPERTY_ON_CHANGE,
    SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS: SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS,
    SET_PAYMENT_INFO: SET_PAYMENT_INFO,
    SET_SELECTED_FACETS_EDIT_COPY: SET_SELECTED_FACETS_EDIT_COPY,
    SET_SELECTED_OFFER: SET_SELECTED_OFFER,
    SET_SELECTED_OFFER_EDIT_COPY: SET_SELECTED_OFFER_EDIT_COPY,
    SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY: SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY,
    SET_SELECTED_WIZARD_TAB: SET_SELECTED_WIZARD_TAB,
    UPDATE_BILL_CYCLE: UPDATE_BILL_CYCLE,
    UPDATE_EDIT_BRI_PRICE: UPDATE_EDIT_BRI_PRICE,
    UPDATE_INVENTORY_SELECTION: UPDATE_INVENTORY_SELECTION,
    UPDATE_OFFER_ATTRIBUTE: UPDATE_OFFER_ATTRIBUTE,
    UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL: UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL,
    UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE: UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE,
    UPDATE_PAYMENT_INFO: UPDATE_PAYMENT_INFO,
    UPDATE_PORT_IN_REQUEST: UPDATE_PORT_IN_REQUEST,
    UPDATE_SELECTED_SERVICE_FEATURES: UPDATE_SELECTED_SERVICE_FEATURES,
    UPDATE_SHOPPING_CART: UPDATE_SHOPPING_CART,
    cancelWizard: cancelWizard,
    clearQuoteAndSetSelectedOffer: clearQuoteAndSetSelectedOffer,
    fetchAddresses: fetchAddresses,
    fetchAttributes: fetchAttributes,
    fetchAttributesAndNavigate: fetchAttributesAndNavigate,
    fetchDecisionsAndNavigate: fetchDecisionsAndNavigate,
    fetchWallet: fetchWallet,
    goToNextStep: goToNextStep,
    goToPreviousStep: goToPreviousStep,
    goToStep: goToStep,
    resetOfferAdditionalProperties: resetOfferAdditionalProperties,
    restoreOptionDefaultPricing: restoreOptionDefaultPricing,
    saveOptionEdit: saveOptionEdit,
    saveBulkPricing: saveBulkPricing,
    searchAttributeInventory: searchAttributeInventory,
    sendPortInOrItemReservation: sendPortInOrItemReservation,
    setCurrentStepIsInvalid: setCurrentStepIsInvalid,
    setEditAttributeGroups: setEditAttributeGroups,
    setEditOption: setEditOption,
    setEditCartAdditionalProperty: setEditCartAdditionalProperty,
    setEditCartAdditionalPropertyOnChange: setEditCartAdditionalPropertyOnChange,
    setEditOrderAdditionalProperty: setEditOrderAdditionalProperty,
    setEditOrderAdditionalPropertyOnChange: setEditOrderAdditionalPropertyOnChange,
    setEditOfferAdditionalProperty: setEditOfferAdditionalProperty,
    setEditOfferAdditionalPropertyOnChange: setEditOfferAdditionalPropertyOnChange,
    setEditPhysicalAttributeGroups: setEditPhysicalAttributeGroups,
    setPaymentInfo: setPaymentInfo,
    setSelectedFacetsEditCopy: setSelectedFacetsEditCopy,
    setSelectedOffer: setSelectedOffer,
    setSelectedOfferEditCopy: setSelectedOfferEditCopy,
    setSelectedOfferingChargeTypesEditCopy: setSelectedOfferingChargeTypesEditCopy,
    setSelectedTab: setSelectedTab,
    updateAttribute: updateAttribute,
    updateBillCycle: updateBillCycle,
    updateCart: updateCart,
    updateEditOptionPrice: updateEditOptionPrice,
    updateInventorySelection: updateInventorySelection,
    updateOfferPhysicalInventoryMakeAndModel: updateOfferPhysicalInventoryMakeAndModel,
    updateOfferPhysicalInventoryTypeAttribute: updateOfferPhysicalInventoryTypeAttribute,
    updatePaymentInfo: updatePaymentInfo,
    updatePortInRequest: updatePortInRequest,
    updateSelectedServiceFeatures: updateSelectedServiceFeatures,
    updateShoppingCart: updateShoppingCart,
    updateShoppingCartPromise: updateShoppingCartPromise
  };
});